import React from 'react';

const base =
  'inline-flex items-center justify-center gap-2 font-medium transition-colors duration-150 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus-visible:ring-2 focus-visible:ring-prodia-primary/30 focus-visible:ring-offset-1';

const sizes = {
  sm: 'h-8 px-3 text-xs rounded-lg',
  md: 'h-10 px-4 text-sm rounded-lg',
  lg: 'h-11 px-5 text-sm rounded-lg',
};

const variants = {
  primary: 'bg-prodia-primary text-prodia-primary-foreground hover:bg-prodia-primary-hover',
  secondary:
    'bg-prodia-surface text-prodia-text-primary border border-prodia-border hover:bg-prodia-background',
  danger: 'bg-danger text-white hover:bg-red-700',
  ghost: 'text-prodia-text-secondary hover:bg-prodia-background hover:text-prodia-text-primary',
};

export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  type = 'button',
  children,
  ...props
}) {
  return (
    <button
      type={type}
      className={`${base} ${sizes[size] || sizes.md} ${variants[variant] || variants.primary} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;
